export const mandaIntegrationCase = {
    id: 'manda-integration',
    title: 'AI-Driven Post-M&A Integration',
    subtitle: 'Process Automation & Integration',
    category: 'AI & Automation',
    description: 'Leveraged AI automation to accelerate post-merger integration processes, reducing timeline from 18 months to 8 months.',
    status: 'info',
    tags: ['AI', 'M&A', 'Process Automation', 'Integration'],
    coverImage: '/cospin-logo.png',
    heroImage: '/cospin-logo.png',
    challenge: `A major healthcare technology company faced complex integration challenges following a strategic acquisition. Traditional integration approaches estimated an 18-month timeline, risking market opportunities and employee retention.`,
    solution: `Cospin developed an AI-driven integration framework:
  • Custom AI models for process mapping and optimization
  • Automated data migration and validation systems
  • ML-powered duplicate detection and resolution
  • Intelligent workflow automation for system integration
  • Predictive analytics for risk identification`,
    results: [
        'Reduced integration timeline from 18 to 8 months',
        'Automated 70% of data migration tasks',
        'Achieved 99.9% data accuracy in system integration',
        'Saved $2.8M in integration costs',
        'Retained 95% of key personnel during transition'
    ],
    metrics: {
        timeframe: '8 months',
        costSavings: '$2.8M',
        automationRate: '70%',
        timelineReduction: '56%'
    },
    testimonial: {
        quote: "The AI-driven approach not only accelerated our integration but also significantly reduced errors and risks. It was a game-changer for our M&A process.",
        author: "CTO, Healthcare Technology Company"
    },
    filePath: '/case-studies/Cospin_CaseStudy_MandAIntegration.pdf'
};
